export const ALL = ['superadmin', 'admin', 'client', 'supervisor'];
export const SUPERADMIN_ONLY = ['superadmin'];
export const ADMIN_ONLY = ['superadmin', 'admin'];
export const SUPERVISOR_ONLY = ['supervisor'];
export const CLIENT_ONLY = ['client'];
export const OPS_ONLY = ['superadmin', 'ops'];
export const NO_SUPERVISOR = ['superadmin', 'admin', 'client'];
export const NO_CLIENT = ['superadmin', 'admin', 'supervisor'];

export const checkSuper = (type) =>
  SUPERADMIN_ONLY.some((level) => level === type);
export const checkAdmin = (type) => ADMIN_ONLY.some((level) => level === type);
export const checkSupervisor = (type) =>
  SUPERVISOR_ONLY.some((level) => level === type);
export const checkClient = (type) =>
  CLIENT_ONLY.some((level) => level === type);
export const checkNoSupervisor = (type) =>
  NO_SUPERVISOR.some((level) => level === type);
export const checkNoClient = (type) =>
  NO_CLIENT.some((level) => level === type);
